export default __webpack_public_path__ + "static/media/background_6_large.31582151.jpg";